<template>
  <draggable class="nestable-table-body" tag="div" v-model="rowList" @change="listUpdated" v-bind="dragOptions" :group="uuid" handle=".nestable-table-row-handle">
    <template v-for="(row, index) in rowList">
      <div :key="row.id">
        <slot name="rowSlot" :index="index" v-bind:item="row" :nestLevel="nestLevel" :parent="parentItem" />

        <NestableTableList v-if="hasChildren(row)" :rows="row[childListProperty]" @update="row[childListProperty] = $event; listUpdated()" :parentItem="row" :nestLevel="nestLevel+1" :key="`${row.id}-child-list`" :rowClass="getRowClass(index)" :editing="editing">
          <template v-for="slot in Object.keys($scopedSlots)" v-slot:[slot]="scope">
            <slot :name="slot" v-bind="scope"/>
          </template>
        </NestableTableList>
      </div>
    </template>
  </draggable>
</template>

<script>
import _ from 'lodash'
import draggable from 'vuedraggable'

export default {
  name: 'NestableTableList',
  components: {
    draggable
  },
  computed: {
    dragOptions() {
      return {
        disabled: !this.editing,
        ghostClass: "ghost"
      };
    },
    indentDisplay() {
      return '&nbsp;'.repeat(this.nestLevel*3) + (this.nestLevel > 0 ? '<i class="fas fa-caret-right"></i>&nbsp;&nbsp;' : '')
    }
  },
  props: {
    parentItem: Object,
    rows: Array,
    rowClass: String,
    editing: Boolean,
    nestLevel: {
      type: Number,
      default: 0
    },
    childListProperty: {
      type: String,
      default: 'childItems'
    }
  },
  data() {
    return {
      rowList: _.cloneDeep(this.$props.rows)
    }
  },
  watch: {
    rows: function(newVal) {
      this.$data.rowList = _.cloneDeep(this.$props.rows)
    },
  },
  methods: {
    hasChildren(row) {
      return (row[this.childListProperty] && row[this.childListProperty].length > 0)
    },
    getRowClass(index) {
      if(this.nestLevel == 0) {
        if((index & 1) == 0)
          return 'striping-row-odd'
      } else {
        return this.rowClass
      }
    },
    listUpdated(evt) {
      this.$emit('update', this.rowList)
    }
  }
}
</script>